module.exports = __webpack_public_path__ + "static/media/ant.3d7f1c3d.svg";